import { useResource } from 'json-api-hooks';
import React, { FC } from 'react';

import ContentDetails from '../../components/ContentDetails';
import { LoadingDetail } from '../../components/Loading';
import DepartmentDetail from '../../details/DepartmentDetail';
import EventTypeDetail from '../../details/EventTypeDetail';
import LocationDetail from '../../details/LocationDetail';
import ParticipantsCountDetail from '../../details/ParticipantsCountDetail';
import StartDateDetail from '../../details/StartDateDetail';
import { EventResource } from '../../models';

const EventDetails: FC<{ event?: EventResource }> = ({ event }) => {
  const departmentIdentifier = event?.relationships.department?.data;
  const [department] = useResource(departmentIdentifier);

  if (!event) {
    return (
      <ContentDetails>
        <LoadingDetail />
      </ContentDetails>
    );
  }

  return (
    <ContentDetails>
      <EventTypeDetail event={event} />
      <ParticipantsCountDetail event={event} />
      {departmentIdentifier && <DepartmentDetail department={department} />}
      <StartDateDetail event={event} />
      <LocationDetail event={event} />
    </ContentDetails>
  );
};

export default EventDetails;
